<template>
  <div class="mobile-social-responsibility">
    <!-- 固定Banner图 -->
    <div class="mobile-social-banner">
      <img 
        :src="require('@/assets/aboutSailHero/img/banner_1.jpg')" 
        alt="社会责任"
        class="mobile-social-banner__image"
      />
      <div class="mobile-social-banner__overlay"></div>
      <div class="mobile-social-banner__content">
        <h1 class="mobile-social-banner__title">社会责任</h1>
        <p class="mobile-social-banner__subtitle">SOCIAL RESPONSIBILITY</p>
      </div>
    </div>

    <!-- 社会责任列表 -->
    <div class="mobile-social-container">
      <!-- 加载状态 -->
      <div class="mobile-social-loading" v-if="loading && socialList.length === 0">
        <div class="mobile-social-loading__spinner"></div>
        <p class="mobile-social-loading__text">加载中...</p>
      </div>

      <!-- 列表内容 -->
      <div class="mobile-social-list" v-else-if="displayList && displayList.length > 0">
        <div
          v-for="(item, index) in displayList"
          :key="item.id || index"
          class="mobile-social-card"
          @click="openImage(item)"
        >
          <!-- 全宽图片 -->
          <div class="mobile-social-card__image-wrapper">
            <img 
              v-if="item.fileUrl" 
              :src="item.fileUrl" 
              :alt="item.about_name"
              class="mobile-social-card__image"
            />
            <span v-else class="mobile-social-card__image-placeholder">📷</span>
          </div>

          <!-- 信息区域 -->
          <div class="mobile-social-card__info">
            <h3 class="mobile-social-card__title">{{ item.about_name || '社会责任活动' }}</h3>
            <p class="mobile-social-card__date" v-if="item.update_time">
              {{ formatDate(item.update_time) }}
            </p>
          </div>
        </div>

        <!-- 查看更多按钮 -->
        <div class="mobile-social-loadmore" v-if="hasMore">
          <button 
            class="mobile-social-loadmore__button"
            @click="showMore"
            :disabled="loadingMore"
          >
            <span v-if="loadingMore">加载中...</span>
            <span v-else>查看更多</span>
          </button>
        </div>
        
        <!-- 全部加载完毕提示 -->
        <div class="mobile-social-loadmore" v-else>
          <p class="mobile-social-loadmore__text">已加载全部内容</p>
        </div>
      </div>

      <!-- 空状态 -->
      <div class="mobile-social-empty" v-else>
        <div class="mobile-social-empty__icon">🌍</div>
        <p class="mobile-social-empty__text">暂无社会责任信息</p>
        <p class="mobile-social-empty__subtext">敬请期待更多内容</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileSocialResponsibility",
  data() {
    return {
      socialList: [],           // 完整的社会责任列表（倒序）
      displayCount: 5,          // 当前显示的数量
      loading: false,           // 初始加载状态
      loadingMore: false,       // 加载更多状态
      pageSize: 100,            // 一次性加载所有数据
      total: 0                  // 总数
    };
  },
  computed: {
    // 当前显示的列表（取前displayCount条）
    displayList() {
      return this.socialList.slice(0, this.displayCount);
    },
    // 是否还有更多数据可以显示
    hasMore() {
      return this.displayCount < this.socialList.length;
    }
  },
  methods: {
    /**
     * 获取社会责任列表（一次性加载所有数据）
     */
    fetchSocialList() {
      const _this = this;
      _this.loading = true;

      _this.$api.post(
        "/Client/getSocialResponsibility",
        {
          pageSize: _this.pageSize,
          pageIndex: 1
        },
        function (res) {
          _this.loading = false;

          if (res.code === "200") {
            const data = res.data || [];
            _this.total = res.count || 0;

            // 倒序排列（最新的在前）
            _this.socialList = data.reverse();
            
            // 重置显示数量为5
            _this.displayCount = 5;
          }
        },
        function (error) {
          _this.loading = false;
          console.error('获取社会责任列表失败:', error);
        }
      );
    },

    /**
     * 查看更多（每次增加5条）
     */
    showMore() {
      if (this.hasMore) {
        this.loadingMore = true;
        
        // 模拟加载延迟，提升用户体验
        setTimeout(() => {
          this.displayCount += 5;
          this.loadingMore = false;
        }, 300);
      }
    },

    /**
     * 打开图片大图
     * @param {Object} item - 社会责任项数据
     */
    openImage(item) {
      if (item.fileUrl) {
        window.open(item.fileUrl, '_blank');
      }
    },

    /**
     * 格式化日期
     * @param {String} dateStr - 日期字符串
     * @return {String} 格式化后的日期
     */
    formatDate(dateStr) {
      if (!dateStr) return '';
      
      try {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      } catch (error) {
        return dateStr;
      }
    }
  },

  mounted() {
    // 页面加载时获取数据
    this.fetchSocialList();
  }
};
</script>

<style scoped>
@import '../../../assets/aboutSailHero/css/social-responsibility-mobile.css';
</style>

